export { getLinkActionGoal, GoalType } from './getLinkActionGoal'
